/**
 * A rabbit — the smallest thing in the valley with a body (M3-10).
 *
 * It exists because the valley was empty. Four dens in a 65,536-tile commote
 * capped the whole population at ten animals and put all of them in the north;
 * what a player needs within a few minutes' walk of the village is something
 * living, and the honest something is a rabbit.
 *
 * Mechanically it is the *control* at the bottom of the scale. Everything the
 * fight rules do is written against a man or a wolf, and a body with a frame of
 * two is what proves those rules degrade sensibly rather than dividing by
 * something. It has no armour, no weapon worth the name, and one portion of meat
 * on it — hunting one is a snack and a lesson, not a living.
 *
 * Hind-heavy, unlike the stag: a rabbit's mass and its whole answer to being
 * caught is behind it, and a hind leg is the part a snare or a thrown stone
 * actually takes.
 */
import { quadruped } from './quadruped.js';
export const RABBIT_PLAN = quadruped({
    id: 'rabbit',
    name: 'rabbit',
    foreleg: 'foreleg',
    hindleg: 'hind leg',
    foot: 'foot',
    // Back-heavy: it presents its rear end to everything, because it is leaving.
    foreWeight: 0.6,
    // Almost all of it is skull. There is not much throat on a rabbit to find.
    skull: 0.8,
});
//# sourceMappingURL=rabbit.js.map